import * as _actions from './actions';
import _skillRecommendation from './model';
import _reducer from './reducer';


export const SkillRecommendation = _skillRecommendation;
export const reducer = _reducer;
export const actions = _actions;



// WEBPACK FOOTER //
// ./data/SkillRecommendation/index.js